module.exports = __webpack_public_path__ + "img/huiyi-img2.87b2d075.jpg";